module.exports = __webpack_public_path__ + "img/photo.21eda349.jpg";